module.exports = __webpack_public_path__ + "static/media/bssh.b0aca859.png";